const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";

const buildUrl = (path, params = {}) => {
  const base = API_BASE_URL ? API_BASE_URL.replace(/\/+$/, "") : "";
  const url = new URL(`${base}${path}`, window.location.origin);
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    url.searchParams.set(key, String(value));
  });
  return url.toString();
};

export async function fetchMetaInsights({ since, until, days } = {}) {
  const url = buildUrl("/api/meta/insights", { since, until, days });
  let response;
  try {
    response = await fetch(url, { credentials: "include" });
  } catch (error) {
    throw new Error(
      `Meta insights fetch failed (network/CORS). URL: ${url}. ${String(
        error?.message || error,
      )}`,
    );
  }
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Meta insights request failed (${response.status}). ${errorText || ""}`.trim(),
    );
  }
  return response.json();
}

export async function fetchMetaHealth() {
  const url = buildUrl("/api/meta/health");
  let response;
  try {
    response = await fetch(url, { credentials: "include" });
  } catch (error) {
    throw new Error(
      `Meta health fetch failed (network/CORS). URL: ${url}. ${String(
        error?.message || error,
      )}`,
    );
  }
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Meta health request failed (${response.status}). ${errorText || ""}`.trim(),
    );
  }
  return response.json();
}
